import { AbstractContractItemViewModel } from './abstract-contract.view-model';

export class ContractsViewModel {
    public contract?: AbstractContractItemViewModel;
    public typeContract: string;
    public brand: string;
    public order: number;
}
